import React from "react"
import { skills } from "../../portfolio"
import SkillsCard from "./SkillsCard"
import Header from "../Header/Header"
function Skills() {
  return (
    <div className="mt-5">
      <div>
        <Header title="Skills" />
        <section>
          <div className="container text-center">
            <div className="row">
              {skills.skills_link.map((val, idx) => {
                return (
                  <SkillsCard key={idx} imgsrc={val.imgsrc} title={val.title} />
                )
              })}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Skills
